import { makeStyles } from '@material-ui/styles'

export const ProfilePopupStyle = makeStyles({
  container: {
    paddingLeft: 18,
    borderRadius: 2,
    zIndex: 999,
    backgroundColor: '#FAFAFA',
    boxShadow:
      '0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)',
  },
  gridContainer: {},
  avatarGrid: {
    marginTop: 20,
    marginLeft: 20,
  },
  center: {
    textAlign: 'right',
  },
  blueArrow: {
    color: '#42AFE4',
    borderColor: '#42AFE4',
  },
  projectLabel: {
    marginRight: '15px',
    display: 'inline',
  },
  projectSelect: {
    marginTop: '10px',
    marginBottom: '10px',
    borderRadius: '4px',
    width: '130px',
    fontSize: '12px',
    textOverflow: 'ellipsis',
    height: '25px',
    marginRight: '15px',
  },
  selectPadding: {
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  avatarIcon: {
    height: 90,
    width: 92,
    color: 'white',
    backgroundColor: '#42AFE4',
  },
  infoGrid: {
    marginTop: 20,
    marginLeft: 15,
    marginRight: 20,
  },
  horizontalDivider: {
    boxSizing: 'border-box',
    height: '2px',
    width: '100%',
    border: '1px solid #E8E8E8',
  },
  profileButton: {
    color: 'white',
    borderRadius: 4,
    backgroundColor: '#42AFE4',
    height: 25,
    fontSize: 13,
    lineHeight: 'normal',
    marginBottom: 14,
    '&&:hover':{
      color: 'white',
      backgroundColor: '#1976d2',
    },
  },
  linkProfileButton: {
    textDecoration: 'none',
  },
  logoutButton: {
    width: '100%',
  },
})
